var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Supports client management from one user to another.
 */
export class ClientService {
    constructor(commonSource) {
        commonSource.subscribe((common) => {
            this.apiResource = common.apiResourceFactory("security/clients");
        });
    }
    create(description, roles) {
        return __awaiter(this, void 0, void 0, function* () {
            const client = (yield this.apiResource.create({
                description,
                roles,
            }));
            return client;
        });
    }
    list() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiResource.get();
        });
    }
    delete(clientId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiResource.delete({
                urlPostfix: `/${clientId}`,
            });
        });
    }
    update(clientId, description, roles) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.apiResource.updateById(clientId, { description, roles });
        });
    }
}
